import { RootState } from '../index';

const getDashboardData = (state: RootState) => state.dashboardReducer.dashboardData;

const getPreset = (state: RootState) => state.dashboardReducer.preset;

export {
  getDashboardData,
  getPreset,
};
